import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, ProgressBar } from 'react-bootstrap';

import LimitAlert from 'Leads/DesignLimitAlert';
import { AuthContext } from 'api/context';

const LicenseDetails = ({ company }) => {
  const { newEndpoint } = useContext(AuthContext);
  const CheckLimitAPI = newEndpoint('designer/limit/check');

  const [AiDesigns, setAiDesigns] = useState();
  const [consumed, setConsumed] = useState();
  const [total, setTotal] = useState();

  // get active license + total and consumed ai designs
  const license = company.active_license?.license_type;
  const designPackage = company?.active_design_package;
  // const [total, consumed] = company.design_packages
  //   .reduce(([tot, con], b) => [tot + b.total_designs, con + b.consumed], [0, 0]);

  const dptype = designPackage?.type?.subscription;

  useEffect(() => {
    CheckLimitAPI.send('POST', {company: company?.id})
      .then((res) => setAiDesigns(res))
      .catch((err) => console.log(err));
  }, [company]);

  useEffect(() => {
    setTotal(designPackage?.total_designs);
    setConsumed(designPackage?.total_designs - AiDesigns?.remained);
  }, [AiDesigns]);

  const now = total ? Math.round(100 * (consumed / total)) : 100;
  const danger = total - consumed <= 0;
  const warning = !danger && total - consumed <= 10;
  // console.log(now, total, consumed, company);

  return (
    <>
      <hr />

      <Row className="my-3">
        <Col>
          <p className="d-inline">Subscription Plan</p>
          <p className="ml-2 p-2 rounded d-inline border border-dark">
            {dptype ? (dptype === 'M' ? 'Monthly' : 'Yearly') : 'N/A'}
          </p>
        </Col>
      </Row>
      <h4 className="my-2 font-weight-bold">Subscription & AI Design Package Information</h4>
      <Row className="my-0" style={{ maxWidth: '750px' }}>
        <Col>
          <h5 className="font-weight-bold">Current AI Design Usage</h5>
          <div>
            <strong>{consumed} / {total}</strong>
          </div>
          <ProgressBar now={now} max={total} striped />
        </Col>
      </Row>
      <Row className="my-2" style={{ maxWidth: '750px' }}>
        <Col>
          <LimitAlert designs={AiDesigns} />
        </Col>
      </Row>
        
      {/*
        <Row className="mt-3">
          <Col>
            <p>{`Current AI design package usage: ${license.license_type.commitment_term === 'year' ? 'Yearly' : 'Monthly'}`}</p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Button variant="primary" disabled>Purchase Additional AI Designs</Button>
          </Col>
        </Row> 
      */}
    </>
  );
};

export default LicenseDetails;
